module.exports = __webpack_public_path__ + "img/amenha.774faced.png";